<form [formGroup]="formDetalhe">
  <div class="row">
    <div class="form-group col-md-12">
      <h4>Dados Bancários</h4> 
    </div>
    <div class="form-group col-md-12">
      <label>Forma de Recebimento do Credor</label> 
      <input id="formaRecebimentoCredor" formControlName="formaRecebimentoCredor"  type="text" class="form-control">
    </div>
    <div class="form-group col-md-12">
      <label>Banco do Credor</label> 
      <input id="codBancoCredor" formControlName="codBancoCredor"  type="text" class="form-control">
    </div>
  </div>
  <div class="row">
    <div class="form-group col-md-4">
      <label>Agência do Credor</label>
      <input id="codAgenciaCredor" formControlName="codAgenciaCredor" type="text" class="form-control">
    </div>
    <div class="form-group col-md-4">
      <label>Conta/ Dígito Verificador</label>
      <input id="contaCredor" formControlName="contaCredor" type="text" class="form-control">
    </div>
    <div class="form-group col-md-4">
      <label>Tipo da Conta do Credor</label>
      <input id="tipoContaCredor" formControlName="tipoContaCredor" type="text" class="form-control">
    </div>
  </div>
  <div class="row">
    <ng-container *ngIf="consignatarias?.length > 0;">
    <div class="form-group col-md-12">
      <h4>Dados da Consignatária</h4>
    </div>
  <div class="form-group col-md-12">
    
    <aslib-grid #grid id="grid"  name="grid" headerTitle="Detalhes Consignatária" [(dataset)]="consignatarias" 
    [selectOnRowClick]="false" [pagination]="false" [regPerPageVisible]="false">  

      <aslib-grid-column [property]="'Id'" [visible]="false" header="Id" class="text-right" [width]="1" [sortable]="true"
        [resizable]="true">
      </aslib-grid-column>
      <aslib-grid-column [property]="'codigoCredor'" header="Código do Credor" class="text-left" [width]="120"
        [sortable]="false" [resizable]="true">
          <ng-template #AslibGridCell let-item="item">
            <span>{{item.codigoCredor | credor}}</span>
          </ng-template>
      </aslib-grid-column>
      <aslib-grid-column [property]="'nomeTipo'" header="Nome" class="text-left"  
        [sortable]="false" [resizable]="false">
          <ng-template #AslibGridCell let-item="item">
            <span>{{item.nomeTipo}}</span>
          </ng-template>
      </aslib-grid-column>
      <aslib-grid-column [property]="'nomeFormaRecebimento'" header="Forma de Recebimento" class="text-left" 
        [sortable]="false" [resizable]="false">
          <ng-template #AslibGridCell let-item="item">
            <span>{{item.nomeFormaRecebimento}}</span>
          </ng-template>
      </aslib-grid-column>
      <aslib-grid-column [property]="'valor'" header="Valor Retido" class="text-right" [width]="120" 
        [sortable]="false" [resizable]="false">
          <ng-template #AslibGridCell let-item="item">
            <span>{{item.valor | currency:'BRL'}}</span>
          </ng-template>
      </aslib-grid-column>       
  </aslib-grid>
</div>
  </ng-container>
  </div>
</form>



// WEBPACK FOOTER //
// ./src/app/pagamento/carga-dados/detalhe-carga-dados.component.html